<template>

<div class="loading-page">
  <i class="fas fa-circle-notch fa-spin loading-page-icon"></i>
</div>

</template>

<script>
export default {
  name: 'LoadingPage'
}
</script>

<style scoped>
.loading-page {
  height: 100%;
  width: 100%;
  padding-top: 70px;
  display: flex;
  justify-content: center;
}

.loading-page-icon {
  font-size: 48px;
}
</style>
